import React, { Component } from 'react';
import './Home.css';
import 'primeicons/primeicons.css';

export class Home extends Component {
  static displayName = Home.name;
          //<div className="w-full ml-2 md:ml-8 text-3xl font-bold"><a href="mailto:info@mozologistics.com">Contact us</a> to find out how we can revolutionize your inventory transportation</div>
      //<div className="main-frame">
      // </div>
    getFeatureCard = (icon, bigText, smallText) => {
        return <div className="feature-frame">
           
            <div className="big-text"><i className={icon} /> {bigText}</div>
            <div className="small-text">{smallText}</div>
        </div>;
    }
  render () {
    return (<>
            <div className="header-frame w-full">
            <div className="big-text">Modernize Your Automotive Inventory Transportation</div>
            <p className="small-text">Mozo Logistics will take the guesswork and manual headache out of getting your auto inventory where it needs to be</p>
            </div>
        <div className="gradient"></div>
      <div className="w-full">

            <div className="w-full feature-container">
                {this.getFeatureCard("pi pi-clock", "Save Time", "Save time with a simplified trip order entry process")}
                {this.getFeatureCard("pi pi-info-circle", "Stay Informed", "Stay engaged with your drivers using mobile notifications")}
                {this.getFeatureCard("pi pi-money-bill", "Save Money", "Save money and time with optimized trip routing and paperless records")}
                {this.getFeatureCard("pi pi-star", "Work Smarter", "Dynamic cost calculation increases transparency and reduces guesswork")}
                {this.getFeatureCard("pi pi-mobile", "Connect Faster", "The Mozo mobile app allows drivers to stay updated and organized (available on both Android and iOS)")}
          </div>

          <div className="w-full m-2 md:m-8 text-2xl text-center">
             <a href="mailto:info@mozologistics.com">Contact us</a> to find out more!
          </div>
       </div>
    </>
    );
  }
}
